module.exports = __webpack_public_path__ + "static/media/APP_Scientist_152x174_5.21d0eb26.png";